export default {
    "IMPORTANT": "Important",
    "NORMAL": "Normal"
}


// WEBPACK FOOTER //
// ./src/Resources/TYPE.js